import { Button } from 'primereact/button'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const LoaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: 100vh;
  z-index: 1102;
`
export const TextButton = styled(Button)`
  height: 50px;
  border-radius: 10px;
  color: #45bfe5 !important;
  font-weight: 700;

  :focus {
    outline: 0 none !important;
    outline-offset: 0;
    box-shadow: none !important;
    background-color: none;
  }
`
export const StyledLink = styled(Link)`
  color: #45bfe5;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-decoration: underline;
`

export const SearchButton = styled(Button)`
  width: 100%;
  height: 50px;
  background: #45bfe5;
  border-radius: 10px;
  text-align: center;
  font-weight: 700;
`

/* ################################## List View Container  ################################## */

export const ListHeader = styled.div`
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 20px;
`

export const ListViewContainer = styled.div`
  position: relative;
  overflow-y: auto !important;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  // margin: 0 0 0.5rem;
  padding: 0 0 0.25rem;
`
export const ListItem = styled.div`
  background: #fff;
  display: flex;
  align-items: center;
  border-top: 1px solid #cecece;

  // &:hover {
  //   background: #fafafa;
  // }

  &:first-of-type {
    border-top: none;
  }

  &:last-of-type {
    border-bottom: 1px solid #cecece;
  }

  .p-radiobutton {
    margin-left: 1rem;
  }

  .location-img {
    width: 25px;
    height: 25px;
    margin: 0 0.5rem 0 0.5rem;
  }

  .list-content {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    gap: 3px;
    padding: 1rem;
    color: #363636;

    .res-date {
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      min-width: 200px;
    }

    .title {
      ont-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      width: 450px;
      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }

    .subtitle {
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }

    .desc {
      color: #21272a;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 120%; /* 19.2px */
    }
  }
`

export const SidebarButton = styled(Button)`
  width: 100%;
  min-width: 250px;
  height: 50px;
  background: #45bfe5;
  border-radius: 10px;
  justify-content: center;
`

/* ################################## Rating Dialog  ################################## */
export const RatingItem = styled.div`
  // display: grid;
  // grid-template-columns: auto 1fr;
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: 20px;
  margin-bottom: 5px;

  .rate-item-title {
    font-size: 14px;
    flex: 1;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    word-wrap: break-word;
    // width: 120px;
    // max-width: 150px;
  }

  .rate-item-btn {
    // flex: 1;
  }
`
